import { TFunction } from "i18next";

import { EventTypeCellParts, EventTypeStrategy } from "./EventTypeStrategy";
import { getTranslatedEventTypeName } from "../../utils/eventTypeUtils";

import { TransactionType } from "@/types/transaction/TransactionType";
import { formatCurrency } from "@/utils/valueFormat";

export class ChannelBudgetUpdatedEventTypeStrategy
implements EventTypeStrategy
{
  renderCell(row: TransactionType, t: TFunction): JSX.Element {
    const forText = row.eventData.channelName ? (
      <>
        {" "}
        {t("for")} <b>{row.eventData.channelName}</b>
      </>
    ) : (
      ""
    );
    const inText = row.eventData.month ? (
      <>
        {" "}
        {t("in")}{" "}
        <b>
          {new Date(row.eventData.month).toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })}
        </b>
      </>
    ) : (
      ""
    );
    const previousAmountText = row.eventData.previousAmount ? (
      <>
        {" | "} {t("common.previous")} {t("common.amount")}:{" "}
        <b>{formatCurrency(row.eventData.previousAmount)}</b>
      </>
    ) : (
      ""
    );

    return (
      <>
        {t(`eventTypes.${row.eventType}`)}
        {forText}
        {inText}
        {previousAmountText}
      </>
    );
  }

  getTypeAndDescription(
    row: TransactionType,
    t: TFunction
  ): EventTypeCellParts {
    const forText = row.eventData.channelName ? (
      <>
        {" "}
        {t("for")} <b>{row.eventData.channelName}</b>
      </>
    ) : (
      ""
    );
    const inText = row.eventData.month ? (
      <>
        {" "}
        {t("in")}{" "}
        <b>
          {new Date(row.eventData.month).toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
          })}
        </b>
      </>
    ) : (
      ""
    );
    const previousAmountText = row.eventData.previousAmount ? (
      <>
        {" | "} {t("common.previous")} {t("common.amount")}:{" "}
        <b>{formatCurrency(row.eventData.previousAmount)}</b>
      </>
    ) : (
      ""
    );

    return {
      type: <>{getTranslatedEventTypeName(row.eventType, t)}</>,
      description: (
        <>
          {forText}
          {inText}
          {previousAmountText}
        </>
      ),
    };
  }
}
